import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ALGOLIA_INDEX_TO_SORT_ORDER } from 'commons/constants';
const CategoryAlgoliaJSONLD = t0 => {
  const $ = _c(11);
  const {
    products,
    pageName,
    pageDescription,
    pageId,
    totalHits,
    currentProductIndex,
    hasProductsLoaded
  } = t0;
  const {
    href
  } = useLocation();
  const sortOrder = ALGOLIA_INDEX_TO_SORT_ORDER[currentProductIndex] || "featured";
  let t1;
  bb0: {
    if (!href && !pageId) {
      t1 = null;
      break bb0;
    }
    const t2 = pageDescription || "";
    const t3 = pageId ?? "";
    let t4;
    if ($[0] !== hasProductsLoaded || $[1] !== href || $[2] !== pageName || $[3] !== products || $[4] !== sortOrder || $[5] !== t2 || $[6] !== t3 || $[7] !== totalHits) {
      const jsonLD = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        url: href,
        description: t2,
        identifier: t3,
        name: pageName
      };
      if (hasProductsLoaded) {
        jsonLD.numberOfItems = totalHits || null;
        jsonLD.itemListElement = products.map(_temp);
        jsonLD.itemListOrder = sortOrder;
      }
      t4 = JSON.stringify(jsonLD);
      $[0] = hasProductsLoaded;
      $[1] = href;
      $[2] = pageName;
      $[3] = products;
      $[4] = sortOrder;
      $[5] = t2;
      $[6] = t3;
      $[7] = totalHits;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t1 = t4;
  }
  const jsonLDString = t1;
  if (!jsonLDString) {
    return null;
  }
  let t2;
  if ($[9] !== jsonLDString) {
    t2 = <Helmet><script type="application/ld+json">{jsonLDString}</script></Helmet>;
    $[9] = jsonLDString;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
CategoryAlgoliaJSONLD.propTypes = {
  products: PropTypes.array.isRequired,
  pageName: PropTypes.string,
  pageDescription: PropTypes.string,
  pageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalHits: PropTypes.number,
  currentProductIndex: PropTypes.string,
  hasProductsLoaded: PropTypes.bool
};
export default CategoryAlgoliaJSONLD;
function _temp(product) {
  return {
    "@type": "Product",
    name: product?.name,
    sku: product?.variantsToShow?.[0]?.sku,
    image: product?.variantsToShow?.[0]?.image ?? "",
    description: product?.name,
    brand: "Joybird",
    offers: {
      "@type": "Offer",
      url: `https://joybird.com${product?.path}`,
      priceCurrency: "USD",
      price: product?.variantsToShow?.[0]?.price,
      availability: product?.variantsToShow?.[0]?.isOutOfStock ? "https://schema.org/OutOfStock" : "https://schema.org/InStock",
      itemCondition: "https://schema.org/NewCondition"
    }
  };
}